import { Theme } from '@mui/material'

const useStyles = {
  avatar: (theme: Theme) => ({
    height: '98px',
    width: '98px',
    backgroundColor: theme.palette.primary.light,
    marginBottom: '12px',
  }),
  avatarIcon: (theme: Theme) => ({
    fontSize: '42px',
    color: theme.palette.primary.dark,
  }),
  recommendedText: (theme: Theme) => ({
    color: theme.palette.ui.tertiaryFixedDim,
    marginTop: '-4px',
  }),
  textEmphasis: {
    fontWeight: '700',
    fontStyle: 'italic',
  },
  sxFooter: {
    height: 'auto',
    zIndex: 1,
  },
  outerContainer: {
    justifyContent: 'center',
    marginTop: '32px',
    gap: '32px',
  },
  photoColumn: {
    flexDirection: 'column',
    alignItems: 'center',
  },
  addPhotoLabel: {
    fontWeight: '600',
  },
  recommendedLabel: {
    fontSize: '13px',
    fontWeight: '500',
    fontStyle: 'italic',
  },
  formContentColumn: {
    flexDirection: 'column',
    gap: 2,
  },
  formHeading: {
    fontWeight: '300',
  },
  formFieldsContainer: {
    marginY: 1,
  },
  notesWrapper: {
    marginBottom: 1,
  },
  captionText: (isMobile: boolean) => ({
    marginLeft: isMobile ? '16px' : 0,
  }),
  optionalLabel: {
    fontWeight: '700',
    fontStyle: 'italic',
  },
  optionalFieldsRow: {
    gap: '12px',
    alignItems: 'flex-start',
  },
}

export default useStyles
